import { IDeposit } from '@interfaces/deposits/i-deposit';

const depositDropDown = (depositList: IDeposit[]) => {
	const updateDeposit = depositList.sort((a, b) => Number(a.amount) - Number(b.amount));

	return [{ id: '', amount: 0, bonus: 0 }, ...updateDeposit];
};

export default depositDropDown;
